import { ReactElement, useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const BathSection = (): ReactElement => {
  const { t: tBath } = useTranslation('', { keyPrefix: '$local.$bathSection' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bathSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Product data array for easier iteration
  const products = [
    {
      key: 'towels',
      link: tBath('towels.link'),
      image: '/images/homepage/hp-towels.webp',
      alt: tBath('towels.alt'),
      title: tBath('towels.title'),
      description: tBath('towels.description'),
    },
    {
      key: 'pajamas',
      link: tBath('pajamas.link'),
      image: '/images/homepage/hp-pajamas.webp',
      alt: tBath('pajamas.alt'),
      title: tBath('pajamas.title'),
      description: tBath('pajamas.description'),
    },
    {
      key: 'slippers',
      link: tBath('slippers.link'),
      image: '/images/homepage/hp-slippers.webp',
      alt: tBath('slippers.alt'),
      title: tBath('slippers.title'),
      description: tBath('slippers.description'),
    },
  ];

  const renderProductCard = (product: (typeof products)[0]) => (
    <Link href={product.link} className="column">
      <img
        src={product.image}
        alt={product.alt}
        className="product-image"
        loading="lazy"
        decoding="async"
        fetchPriority="low"
        width={420}
        height={280}
      />
      <div className="column-copy">
        <h2>{product.title}</h2>
        <p>{product.description}</p>
        <span className="btn-text">{tButton('shopNow')}</span>
      </div>
    </Link>
  );

  return (
    <section className="base-section bath-section hp-section">
      {/* Bath Section */}
      <div className="columns-wrap">
        <Link href={tLinks('bathMain')} className="columns-intro" id="HP_bath">
          <h2>{tBath('bathTitle')}</h2>
          <p>{tBath('bathDescription')}</p>
        </Link>

        {isMobile ? (
          <div className="swiper-container">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1.2}
              navigation
              pagination={{ clickable: true }}
              className="bath-swiper"
            >
              {products.map(product => (
                <SwiperSlide key={product.key}>{renderProductCard(product)}</SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="columns-3col">
            {products.map(product => (
              <div key={product.key}>{renderProductCard(product)}</div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BathSection;
